import { render, staticRenderFns } from "./TellUsWhoYouAre.vue?vue&type=template&id=7a985975&scoped=true&"
import script from "./TellUsWhoYouAre.vue?vue&type=script&lang=js&"
export * from "./TellUsWhoYouAre.vue?vue&type=script&lang=js&"
import style0 from "./TellUsWhoYouAre.vue?vue&type=style&index=0&id=7a985975&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a985975",
  null
  
)

export default component.exports